export const getConfigTable = (tab) => {
    return tab === "prospek"
      ? configTableProspek
      : tab === "appointmentFU"
      ? configReportAppointmentToday
      : configReportAppointmentOverdue;
}

const configTableProspek = [
    {name: "namaSalesmanCS", label: "Nama Salesman/CS", options: {sort: false}},
    {name: "nonFU", label: "Non FU", options: {sort: false}},
    {name: "ongoing", label: "Ongoing", options: {sort: false}},
    {name: "pending", label: "Pending", options: {sort: false}},
];

export const configReportAppointmentToday = [
  { name: "namaSalesmanCS", label: "Nama Salesman/CS", options: { sort: false } },
  { name: "namaKonsumen", label: "Nama Konsumen", options: { sort: false } },
  { name: "alamat", label: "Alamat", options: { sort: false } },
  { name: "kecamatan", label: "Kecamatan", options: { sort: false } },
  { name: "noHape1", label: "No Hape 1", options: { sort: false } },
  { name: "noHape2", label: "No Hape 2", options: { sort: false } },
];

export const configReportAppointmentOverdue = [
  ...configReportAppointmentToday,
  { name: "overdue", label: "Overdue", options: { sort: false } },
];